import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";

// Pages
import HomePage from "@/pages/HomePage";
import WindowsPage from "@/pages/WindowsPage";
import DoorsPage from "@/pages/DoorsPage";
import OutbuildsPage from "@/pages/OutbuildsPage";
import RecentWorkPage from "@/pages/RecentWorkPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import SuccessPage from "@/pages/SuccessPage";
import FAQPage from "@/pages/FAQPage";
import ReviewsPage from "@/pages/ReviewsPage";
import VideosPage from "@/pages/VideosPage";
import LocationPage from "@/pages/LocationPage";
import BacklinksPage from "@/pages/BacklinksPage";

// Components
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import EnergyBanner from "@/components/EnergyBanner";
import FacebookButton from "@/components/FacebookButton";
import CookieConsent from "@/components/CookieConsent";
import AuthCallback from "@/components/AuthCallback";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Router wrapper to handle OAuth callback detection
function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check URL fragment for session_id SYNCHRONOUSLY during render
  // This prevents race conditions by processing OAuth callback FIRST
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/windows" element={<WindowsPage />} />
          <Route path="/doors" element={<DoorsPage />} />
          <Route path="/outbuilds" element={<OutbuildsPage />} />
          <Route path="/recent-work" element={<RecentWorkPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/double-glazing-hamilton" element={<LocationPage locationKey="hamilton" />} />
          <Route path="/double-glazing-motherwell" element={<LocationPage locationKey="motherwell" />} />
          <Route path="/double-glazing-east-kilbride" element={<LocationPage locationKey="east-kilbride" />} />
          <Route path="/double-glazing-airdrie" element={<LocationPage locationKey="airdrie" />} />
          <Route path="/double-glazing-coatbridge" element={<LocationPage locationKey="coatbridge" />} />
          <Route path="/double-glazing-wishaw" element={<LocationPage locationKey="wishaw" />} />
          <Route path="/double-glazing-bellshill" element={<LocationPage locationKey="bellshill" />} />
          <Route path="/double-glazing-glasgow" element={<LocationPage locationKey="glasgow" />} />
          <Route path="/find-us" element={<BacklinksPage />} />
        </Routes>
      </main>
      <EnergyBanner />
      <Footer />
      <FacebookButton />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
